document.addEventListener("DOMContentLoaded", function () {
  // Clear any leftover theme settings to ensure standard white theme is active
  document.body.classList.remove("dark-mode");
  localStorage.removeItem("theme");

  initHeaderScrollState();
  initNavbarFeaturesRename();
  initLaunchTimer();
});

/**
 * Transparent header at top → solid background after scroll.
 * Uses scroll position (not theme sticky-state) so background clears when
 * the user scrolls back to the top. Theme sticky-state can stick "active"
 * because vinescape forces position absolute/fixed on the header.
 */
function initHeaderScrollState() {
  const header = document.querySelector("#header-component");
  if (!header) return;

  const SCROLL_THRESHOLD = 12;
  let rafId = null;
  let lastScrolled = null;

  function getScrollY() {
    // Desktop squeeze layout scrolls .page-wrapper; mobile uses the document.
    if (window.matchMedia("(min-width: 990px)").matches) {
      const pageWrapper = document.querySelector(".page-wrapper");
      if (pageWrapper) return pageWrapper.scrollTop || 0;
    }
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function getScrollTarget() {
    if (window.matchMedia("(min-width: 990px)").matches) {
      return document.querySelector(".page-wrapper") || window;
    }
    return window;
  }

  const HIDE_OFFSET = 180; // only start hiding once past the hero top
  const DIRECTION_JITTER = 4; // ignore sub-pixel/rubber-band noise
  let lastY = getScrollY();

  function applyState() {
    rafId = null;
    const y = getScrollY();
    const scrolled = y > SCROLL_THRESHOLD;
    if (scrolled !== lastScrolled) {
      lastScrolled = scrolled;
      header.classList.toggle("vs-scrolled", scrolled);
      // Keep in sync for any leftover theme/selectors that still read sticky-state
      header.dataset.stickyState = scrolled ? "active" : "inactive";
    }

    // Hide on scroll down, reveal on scroll up
    const delta = y - lastY;
    if (Math.abs(delta) > DIRECTION_JITTER) {
      if (delta > 0 && y > HIDE_OFFSET && !header.matches(":hover, :focus-within")) {
        header.classList.add("vs-header-hidden");
      } else if (delta < 0) {
        header.classList.remove("vs-header-hidden");
      }
      lastY = y;
    }
    if (y <= HIDE_OFFSET) header.classList.remove("vs-header-hidden");
  }

  function onScroll() {
    if (rafId != null) return;
    rafId = requestAnimationFrame(applyState);
  }

  let scrollTarget = getScrollTarget();
  scrollTarget.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () {
    const next = getScrollTarget();
    if (next !== scrollTarget) {
      scrollTarget.removeEventListener("scroll", onScroll);
      scrollTarget = next;
      scrollTarget.addEventListener("scroll", onScroll, { passive: true });
    }
    lastScrolled = null;
    applyState();
  });

  applyState();
}

function initNavbarFeaturesRename() {
  function renameNavbarFeaturesLink() {
    const navLinks = document.querySelectorAll("a, button, span, details summary");
    navLinks.forEach((el) => {
      // Only update leaf nodes to preserve child HTML classes
      if (el.children.length === 0) {
        const text = el.textContent.trim().toUpperCase();
        if (text === "FEATURES" || text === "CONTACT US") {
          el.textContent = "Contact Us";
          const parentLink = el.closest("a");
          if (parentLink) {
            parentLink.setAttribute("href", "/pages/contact");
          }
        }
      }
    });
  }

  renameNavbarFeaturesLink();
  setTimeout(renameNavbarFeaturesLink, 500);
  setTimeout(renameNavbarFeaturesLink, 1500);
  setTimeout(renameNavbarFeaturesLink, 4000);
}

function initLaunchTimer() {
  const section = document.querySelector(".vs-launch-timer");
  if (!section) return;

  const launch = parseInt(section.dataset.launch, 10) * 1000;
  if (!Number.isFinite(launch)) return;

  function updateCountdown() {
    const now = Date.now();
    const diff = launch - now;
    const daysEl = document.getElementById("days");
    const hoursEl = document.getElementById("hours");
    const minutesEl = document.getElementById("minutes");
    const secondsEl = document.getElementById("seconds");
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    if (diff <= 0) {
      daysEl.textContent = "00";
      hoursEl.textContent = "00";
      minutesEl.textContent = "00";
      secondsEl.textContent = "00";
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    daysEl.textContent = String(days).padStart(2, "0");
    hoursEl.textContent = String(hours).padStart(2, "0");
    minutesEl.textContent = String(minutes).padStart(2, "0");
    secondsEl.textContent = String(seconds).padStart(2, "0");
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
}

/* Product description: clamp to a few lines with READ MORE toggle */
document.addEventListener('DOMContentLoaded', function () {
  var desc = document.querySelector('.text-block--text_desc_full');
  if (!desc) return;

  desc.classList.add('vs-desc-clamped');

  // Only offer the toggle when the text actually overflows the clamp
  if (desc.scrollHeight <= desc.clientHeight + 2) {
    desc.classList.remove('vs-desc-clamped');
    return;
  }

  var toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'vs-desc-toggle';
  toggle.textContent = 'Read more';
  desc.insertAdjacentElement('afterend', toggle);

  toggle.addEventListener('click', function () {
    var clamped = desc.classList.toggle('vs-desc-clamped');
    toggle.textContent = clamped ? 'Read more' : 'Read less';
  });
});
